import ApiService from '@/services/core/api.service'

const SurveyQuestionareService = {
  async get (query) {
    return ApiService.get(`admin/survey-questionares?${query}`)
  },

  async post (payload) {
    return ApiService.post('admin/survey-questionares', payload)
  },

  async put (payload) {
    return ApiService.put(`admin/survey-questionares/${payload.id}`, payload)
  }
}

export default SurveyQuestionareService
